
import React from 'react';
import { Link } from 'react-router-dom';

const ApplicationSubmitted: React.FC = () => {
    return (
        <div className="max-w-2xl mx-auto px-4 py-20 text-center animate-in fade-in zoom-in duration-500">
            <div className="w-24 h-24 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center text-5xl mx-auto mb-8 shadow-sm">
                🎉
            </div>
            <h2 className="text-5xl font-black text-gray-900 mb-6 tracking-tight">You're all set!</h2>
            <p className="text-xl text-gray-600 mb-10 leading-relaxed font-medium">
                Thanks for applying to the Queenli creator team.
            </p>

            <div className="bg-white rounded-[2rem] p-8 border border-gray-100 shadow-xl text-left space-y-6 mb-10">
                <h3 className="text-xl font-black text-gray-900">What happens now:</h3>
                <ul className="space-y-4">
                    <li className="flex gap-4 items-start">
                        <div className="w-8 h-8 rounded-full bg-blue-50 text-blue-600 flex items-center justify-center font-bold text-sm mt-1">1</div>
                        <div>
                            <div className="font-bold text-gray-900">Check your email</div>
                            <p className="text-sm text-gray-500">We've sent you the <strong>Test Instructions</strong>. You need to complete this to be considered.</p>
                            <div className="mt-3 bg-amber-50 border border-amber-200 rounded-xl px-4 py-3">
                                <p className="text-sm text-amber-800 font-semibold flex items-center gap-2">
                                    <span>⚠️</span>
                                    <span>Can't find it? Check your <strong>Spam/Junk folder!</strong></span>
                                </p>
                            </div>
                        </div>
                    </li>
                    <li className="flex gap-4 items-start">
                        <div className="w-8 h-8 rounded-full bg-purple-50 text-purple-600 flex items-center justify-center font-bold text-sm mt-1">2</div>
                        <div>
                            <div className="font-bold text-gray-900">Team Review</div>
                            <p className="text-sm text-gray-500">Once you submit your test videos, we review them within 5-7 business days.</p>
                        </div>
                    </li>
                    <li className="flex gap-4 items-start">
                        <div className="w-8 h-8 rounded-full bg-purple-50 text-purple-600 flex items-center justify-center font-bold text-sm mt-1">3</div>
                        <div>
                            <div className="font-bold text-gray-900">Get Approved</div>
                            <p className="text-sm text-gray-500">If approved, you'll receive your contract and onboarding info!</p>
                        </div>
                    </li>
                </ul>
            </div>

            <div className="space-y-4">
                <p className="text-gray-500 font-medium">
                    While you wait, follow us on TikTok: <a href="https://tiktok.com/@queenli" target="_blank" className="text-[#341368] font-bold hover:underline">@queenli</a>
                </p>
                <p className="text-sm text-gray-400">
                    Questions? Reach out at <a href="mailto:contact@torek.io" className="text-purple-600 font-bold hover:underline">contact@torek.io</a>
                </p>

                <div className="pt-8">
                    <Link
                        to="/"
                        className="inline-block px-8 py-3 bg-gray-900 text-white rounded-full font-bold hover:bg-black transition-all"
                    >
                        Back to Home
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default ApplicationSubmitted;
